import { useIonRouter } from '@ionic/react'

const useTabContext = (): string => {
    const { routeInfo: { pathname } } = useIonRouter()
    return pathname.split('/')[1] || 'home'
}

export default useTabContext
